<div class="relative">
  <div class="overlayerContent">
    <div class="p-5 relative">
      <div class="bg-primary-500/70 absolute backdrop-blur-md inset-0"></div>
      <img src="/assets/images/patternHover.png" alt="" class="absolute inset-0 w-full h-full object-fill">

      <div class="mt-3 intro-x grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 w-11/12 min-h-[340px] mx-auto" [style]="{'--order':1, 'opacity' : 0}">
        <ng-container *ngIf="aboutUs$ | async as aboutUs">
          <div class="bg-white px-5 py-3 shadow-sm rounded-lg shadow-secondary-100 flex gap-3">
            <img src="/assets/images/new-tgsd-logo.svg" alt="Dirisha la Huduma za Serikali" class="h-10 lg:h-20 md:h-20 sm:h-14 cursor-pointer self-center"/>
            <div class="flex flex-col">
              <h2 class="text-primary-500 border-b-2 border-secondary-400 py-2">
                {{ "Kuhusu dirisha la huduma za serikali"|concat|translate }}
              </h2>
              <p class="text-sm text-gray-700 whitespace-pre-line">
                {{ aboutUs[0]?.content }}
              </p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="objective$ | async as objectives">
          <div class="bg-white px-5 py-3 shadow-sm rounded-lg shadow-secondary-100 flex flex-col">
            <h2 class="text-primary-500 border-b-2 border-secondary-400 py-2">
              {{ "Malengo"|concat|translate }}
            </h2>
            <ul class="list-disc flex flex-col gap-2 text-[16px]">
              <li *ngFor="let item of objectives">{{ item.content }}</li>
            </ul>
          </div>
        </ng-container>
        <ng-container *ngIf="benefit$ | async as benefits">
          <div class="bg-white px-5 py-3 shadow-sm rounded-lg shadow-secondary-100 flex flex-col">
            <h2 class="text-primary-500 border-b-2 border-secondary-400 py-2">
              {{ "Faida"|concat|translate }}
            </h2>
            <ul class="list-disc flex flex-col gap-2 text-[16px]">
              <li *ngFor="let item of benefits">{{ item.content }}</li>
            </ul>
          </div>
        </ng-container>

      </div>
    </div>
    <div (mouseover)="exitHover.emit(null)" class="min-h-[170vh] w-full backdrop-blur-lg"></div>
  </div>
</div>
